import script from "./editVisit.vue?vue&type=script&setup=true&lang=js"
export * from "./editVisit.vue?vue&type=script&setup=true&lang=js"

import "./editVisit.vue?vue&type=style&index=0&id=b3e742d0&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3e742d0"]])

export default __exports__